import * as Yup from 'yup'
import { emailSchema } from './email.validation'

export const accountManualSchema = Yup.object().shape({
  account_holder: Yup.string()
    .max(100, 'validation-account-holder-max')
    .required('validation-required'),
  email: emailSchema.nullable(true),
  address: Yup.string().max(200, 'validation-address-max').nullable(true),
  website: Yup.string().url('validation-url-invalid').nullable(true),
})
